import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Grid, Button } from "@material-ui/core";
import MaterialTable from "material-table";
import { useSelector } from "react-redux";
import { tableIconsInputScreen } from "../../../Utilities/Utility";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import Loader from "../../../Components/Loader/Loader";
import { getCompanyList } from "../../../Redux/API/api_master";

export default function CompanyMasterList() {
  const siteToken = useSelector((state) => state.saveTokenReducer.token);
  const bearerToken = useSelector((state) => state.saveBearerTokenReducer.bearerToken);
  const uId = useSelector((state) => state.saveUIDReducer.uid);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const [masterData, setMasterData] = useState([]);
  let [isLoader, setIsLoader] = useState(false);

  //const token = useSelector((state) => state.saveTokenReducer.token);

  function GetEditButton(rowData) {
    return (
      <Tooltip title="Edit Company" placement="bottom">
        <span>
          <Button href="javascript:void(0)">
            <span>
              <EditOutlinedIcon fontSize="small" className="attachFileIcon" />
            </span>
          </Button>
        </span>
      </Tooltip>
    );
  }

  function btoaSecure(value) {
    const { btoa } = require("abab");
    let currDate = new Date().toDateString();
    let valueModified = value + " " + currDate;
    let valueSecured = btoa(btoa(valueModified));
    return valueSecured;
  }

  function clickEditHardCodeMaster(rowData) {
    let id = rowData.companyId;
    let idEncrypted = btoaSecure(id);
    window.location.href = "/addCompany?id=" + idEncrypted;
  }

  const columns = [
    // { title: "Sr No.", field: "hardCodeId" },
    { title: "Company Id", field: "companyId", hidden: true },
    { title: "Company Code", field: "companyCode" },
    { title: "Company Name", field: "companyName" },
    { title: "IEC Code", field: "iecCode" },
    { title: "ARE Code", field: "areCode" },
    { title: "Country", field: "countryName" },
    {
      title: "Status",
      field: "statusValue",
    },
  ];

  function clickAddHardCodeMaster() {
    window.location.href = "/addCompany";
  }
  function getCompany() {
    setIsLoader(true);
    getCompanyList(siteToken,bearerToken,userDetails.emailId,userDetails.gid,userDetails.roleId,userDetails.roleName,uId)
      .then((response) => {
        setMasterData(response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  useEffect(() => {
    getCompany();
  }, [siteToken]);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12} className="d-flex jc-space-bt">
          <Grid item xs={9} className="text-left ml-1">
            <h2>Company List</h2>
          </Grid>
          <Grid item xs={3} className="text-right"></Grid>
        </Grid>
        <Grid item xs={12}>
          <MaterialTable
            title=""
            columns={columns}
            data={masterData}
            icons={tableIconsInputScreen}
            options={{
              exportButton: {
                csv: true,
                pdf: false,
              },
              search: true,
              exportAllData: true,
              pageSize: 10,
              emptyRowsWhenPaging: false,
              exportFileName: "CompanyList",
              rowStyle: (x) => {
                if (x.tableData.id % 2) {
                  return { backgroundColor: "#F2FCFC" };
                } else {
                  return { backgroundColor: "white" };
                }
              },
            }}
            actions={[
              {
                icon: AddIcon,
                isFreeAction: true,
                tooltip: "Add Company",
                onClick: () => {
                  clickAddHardCodeMaster();
                },
              },
              {
                icon: GetEditButton,
                tisFreeAction: true,

                onClick: (event, rowData) => clickEditHardCodeMaster(rowData),
              },
            ]}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={1} className="mb-1">
        <Link to={"/admin"}>
          <Button
            type="submit"
            className="pt-button--tertiary"
            id="SupplierLoginBtn"
            fullWidth>
            &lt; &lt; Back
          </Button>
        </Link>
      </Grid>
      {isLoader ? <Loader loaderText="Loading...." /> : <></>}
    </div>
  );
}
